"use client";

import type { ReactNode } from "react";
import { ConvexProvider } from "convex/react";
import { createBrowserConvexClient } from "@/lib/convex/traced-client";
import { safeWebSocketConstructor } from "@/lib/safe-websocket";
import { requiredPublicConfigValue } from "@/lib/public-config";

let publicConvex: ReturnType<typeof createBrowserConvexClient> | undefined;

function publicConvexClient() {
  publicConvex ??= createBrowserConvexClient(requiredPublicConfigValue("NEXT_PUBLIC_CONVEX_URL"), {
    webSocketConstructor: safeWebSocketConstructor(),
  });
  return publicConvex;
}

export function PublicConvexProvider({ children }: { children: ReactNode }) {
  return <ConvexProvider client={publicConvexClient()}>{children}</ConvexProvider>;
}
